const currencies={
    "AR":"ARS",
    "CO": "COP",
    "CL": "CLP",
    "PE":"PEN",
    "EC": "USD",
    "GT": "GTQ",
    "MX":"MXN",
    "US": "USD",
}
export default currencies